export const AlertCodeAFI = 'AFI' // DBで管理していない特別な値
export const AlertCodeAL100004 = 'AL100004' // 貸出処理を完了します。よろしいですか。
export const AlertCodeAL100007 = 'AL100007' // 資料番号：{0}には{1}の付録があります。
export const AlertCodeAL100011 = 'AL100011' // 資料番号：{0}は貸出を取消します。よろしいですか。
export const AlertCodeAL300018 = 'AL300018' // 選択した情報を削除してよろしいですか。
export const AlertCodeAL300031 = 'AL300031' // 検索履歴をすべて削除してよろしいですか。
export const AlertCodeAL300032 = 'AL300032' // 処理館と処理場所が対応していません。処理を続行してよろしいですか。
export const AlertCodeAL300034 = 'AL300034' // 発注します。よろしいですか。
export const AlertCodeAL300035 = 'AL300035' // 発注リストを削除します。よろしいですか。
export const AlertCodeAL300036 = 'AL300036' // 選定候補を却下します。よろしいですか。
export const AlertCodeAL300037 = 'AL300037' // 選定情報を削除します。よろしいですか。
export const AlertCodeAL300039 = 'AL300039' // {0}には予約があります。資料に予約を割り当てますか。
export const AlertCodeAL300040 = 'AL300040' // 該当発注情報が{0}件ありました。一括受入しますか。
export const AlertCodeAL300042 = 'AL300042' // {0}を行います。該当資料を手元に準備してから、OKボタンをクリックして下さい。
export const AlertCodeAL300044 = 'AL300044' // 館（{0}:{1}）で二重発注となります。発注しますか。
export const AlertCodeAL300047 = 'AL300047' // 回送館が変更されました。予約回送中に変更してもよろしいですか。
export const AlertCodeAL300048 = 'AL300048' // この書誌は既に登録されています。上書きしますか。（内容書誌の資料形態は端末パラメータ設定の値で上書きされます。）
export const AlertCodeAL300050 = 'AL300050' // 予約有効期限日をクリアします。よろしいですか。
export const AlertCodeAL300051 = 'AL300051' // 予約を削除します。よろしいですか。
export const AlertCodeAL300052 = 'AL300052' // 回送依頼を行いますか。キャンセルの場合、予約を行います。
export const AlertCodeAL300054 = 'AL300054' // ここの値はDB上に登録されていないので特殊
export const AlertCodeAL300062 = 'AL300062' // 予約状態を{0}に変更します。よろしいですか。
export const AlertCodeAL300067 = 'AL300067' // 現在表示している初期値情報を削除します。よろしいですか。
export const AlertCodeAL400002 = 'AL400002' // 暗証番号を初期化しますか。
export const AlertCodeAL400003 = 'AL400003' // 家族番号が登録されています。処理を続行しますか。
export const AlertCodeAL400013 = 'AL400013' // 利用者を統合してよろしいですか。
export const AlertCodeAL400015 = 'AL400015' // 利用者情報を削除してよろしいですか。
export const AlertCodeAL400022 = 'AL400022' // 督促履歴を削除します。よろしいですか。
export const AlertCodeAL400023 = 'AL400023' // 入力された利用者情報には類似情報が{0}件存在します。登録を行いますか。
export const AlertCodeAL500001 = 'AL500001' // 典拠情報を統合してもよろしいですか。
export const AlertCodeAL500002 = 'AL500002' // 統一形に変更しますか。
export const AlertCodeAL600001 = 'AL600001' // パスワードを変更します。よろしいですか。
export const AlertCodeAL600002 = 'AL600002' // 紛失処理と蔵書点検処理のクリアを行います。よろしいですか。
export const AlertCodeAL600004 = 'AL600004' // {0}が設定されていません。よろしいですか。
export const AlertCodeAL900001 = 'AL900001' // 管理番号が入力されていません。自動設定しますか。
export const AlertCodeAL900002 = 'AL900002' // 選択した情報を全て協同データベース登録済にし、CSV出力を行いますか。キャンセルの場合、CSV出力のみ行います。
export const AlertCodeALC00002 = 'ALC00002' // 画面が切り替わります。編集中のデータがある場合、編集内容は反映されませんが、よろしいですか。
export const AlertCodeALC00004 = 'ALC00004' // 画面が切り替わります。編集中のデータがある場合、編集内容は{0}されません。{1}へ遷移してもよろしいですか。
export const AlertCodeALC00005 = 'ALC00005' // 現在編集中の内容を更新しますか。
export const AlertCodeALC00007 = 'ALC00007' // {0}情報を{1}します。よろしいですか。
export const AlertCodeALC00008 = 'ALC00008' // 選択した{0}を{1}します。よろしいですか。
export const AlertCodeALC00009 = 'ALC00009' // 該当の{0}は存在しません。新規に登録を行いますか。
export const AlertCodeALC00010 = 'ALC00010' // {0}は複写先に既に存在します。上書きしますか。
export const AlertCodeALC00012 = 'ALC00012' // {0}を行いますか。
export const AlertCodeALC00015 = 'ALC00015' // 該当件数が{0}件です。{1}を行いますか。
export const AlertCodeALC00016 = 'ALC00016' // {0}処理を完了します。よろしいですか。
export const AlertCodeBAT00015 = 'BAT00015' // セッションがタイムアウトしました。ログアウトします。
export const AlertCodeCLT00009 = 'CLT00009' // 基点画面へ戻ります。\n編集中のデータがある場合、編集内容は反映されません。
export const AlertCodeCLT00011 = 'CLT00011' // タグは既に業界コード：{0}館種別：{1}機関コード：{2}資料番号：{3}が登録されています。資料情報を上書きしますか。
export const AlertCodeCLT00012 = 'CLT00012' // {0}の書き込みは失敗しました。
export const AlertCodeCLT00013 = 'CLT00013' // ICタグの書き込みは正常に終了しました。
export const AlertCodeCLT00023 = 'CLT00023' // ICタグの読み込みに失敗しました。
export const AlertCodeCLT00033 = 'CLT00033' // 既に利用者情報が登録されているカードです。利用者情報を上書きしますか。
export const AlertCodeCLT00034 = 'CLT00034' // リライトカードが挿入されていません。処理を続行してよろしいですか。
export const AlertCodeCLT00035 = 'CLT00035' // リライトカードの利用者情報と画面上の利用者情報が不一致です。リライトカードを上書きしますか。
export const AlertCodeCLT00042 = 'CLT00042' // {0}情報を登録します。よろしいですか。
export const AlertCodeCLT00050 = 'CLT00050' // {0}処理を行います。よろしいですか。
export const AlertCodeICT = 'ICT' // DB上で管理していない特別なコード値
export const AlertCodeIL300062 = 'IL300062' // 該当書誌を{0}選択して下さい。
export const AlertCodeIL300079 = 'IL300079' // 統合される書誌は削除されます。よろしいですか。
export const AlertCodeIL700015 = 'IL700015' // {0}が設定されていません。
export const AlertCodeILC00001 = 'ILC00001' // {0}が重複しています。
export const AlertCodeILC00005 = 'ILC00005' // {0}する{1}を選択して下さい。
export const AlertCodeILC00018 = 'ILC00018' // {0}は必須項目です。入力して下さい。
export const AlertCodeILC00020 = 'ILC00020' // {0}を正しく設定して下さい。
export const AlertCodeILC00021 = 'ILC00021' // {0}を選択して下さい。
export const AlertCodeILC00023 = 'ILC00023' // {0}を複数選択することはできません。
export const AlertCodeILC00024 = 'ILC00024' // 該当の{0}は存在しません。
export const AlertCodeILC00031 = 'ILC00031' // 入力された{0}は既に入力済みです。
export const AlertCodeILC00032 = 'ILC00032' // 入力された{0}は存在しません。
export const AlertCodeILC00036 = 'ILC00036' // 削除する{0}を選択して下さい。
export const AlertCodeILC00040 = 'ILC00040' // {0}は選択できません。
export const AlertCodeINF00001 = 'INF00001' // 『{0}』に「{1}」の{2}があります。
export const AlertCodeINF00002 = 'INF00002' // 『{0}』には{1}があります。
export const AlertCodeINF00003 = 'INF00003' // 『{0}』には「{1}」の付録があります。
export const AlertCodeINF00004 = 'INF00004' // {0}を{1}します。リライトカードを挿入し、[OK]ボタンを押してください。
export const AlertCodeMKPF = 'MKPF' // DB上で管理していない特別なコード値
export const AlertCodeML200004 = 'ML200004' // 資料番号：{0}は{1}の付録があります。
export const AlertCodeML200012 = 'ML200012' // 資料番号：{0}に「{1}」の{2}があります。
export const AlertCodeML300017 = 'ML300017' // {0}には予約があります。
export const AlertCodeML300019 = 'ML300019' // 該当の発注番号は発注取消済みです。
export const AlertCodeML300026 = 'ML300026' // CSV出力を行いました
export const AlertCodeML600003 = 'ML600003' // ユーザーＩＤ［{0}］のパスワードを変更しました。
export const AlertCodeMLC00002 = 'MLC00002' // {0}を複写しました。
export const AlertCodeMLC00005 = 'MLC00005' // 該当件数が{0}件あります。{1}件だけ一覧表示します。
export const AlertCodeRLC00007 = 'RLC00007' // 本がアンテナ上に置かれていません。本をアンテナ上に置いて下さい。
export const AlertCodeRLC00008 = 'RLC00008' // 本がアンテナ上に複数冊置かれています。１冊のみ置いて下さい。
export const AlertCodeRLC00009 = 'RLC00009' // 利用者カードがアンテナ上に置かれていないか複数枚置かれています。１枚のみ置いて下さい。
export const AlertCodeRLC00010 = 'RLC00010' // 利用者カードがアンテナ上に置かれていません。利用者カードをアンテナ上に置いて下さい。
export const AlertCodeRLC00011 = 'RLC00011' // 利用者カードが読み込めません。アンテナ上に利用者カードを読み込めるように置いて下さい。
export const AlertCodeSLC00002 = 'SLC00002' // {0}が存在しません。
export const AlertCodeTL100030 = 'TL100030' // 資料番号：{0}は{1}です。
export const AlertCodeTL100040 = 'TL100040' // 資料番号：{0}は、今回貸出されています。処理できません。
export const AlertCodeTL200007 = 'TL200007' // 資料番号：{0}は{1}です。{2}できません。
export const AlertCodeTL300003 = 'TL300003' // {0}が違うため、{1}はできません。
export const AlertCodeTL300009 = 'TL300009' // {0}のため更新できません。
export const AlertCodeTL300035 = 'TL300035' // 該当の書誌は統合先書誌と同一です。
export const AlertCodeTL300050 = 'TL300050' // 該当範囲の資料番号は既に入力済みか、表示できない資料です。
export const AlertCodeTL300082 = 'TL300082' // 製本元資料に製本資料と同一の資料番号は入力できません。
export const AlertCodeTL400016 = 'TL400016' // 該当の利用者は統合先利用者と同一です。
export const AlertCodeTL400020 = 'TL400020' // 他の利用者と家族登録されているため、処理できません。
export const AlertCodeTL400035 = 'TL400035' // 利用者は団体利用者のため、家族登録はできません。
export const AlertCodeTL700020 = 'TL700020' // 該当{0}は複数存在します。
export const AlertCodeTLC00003 = 'TLC00003' // {0}のため、{1}はできません。
export const AlertCodeTLC00007 = 'TLC00007' // {0}はありません。
export const AlertCodeTLC00010 = 'TLC00010' // {0}は他端末で{1}されました。確認して下さい。
export const AlertCodeTLC00016 = 'TLC00016' // 内容が変更されていないため、この処理は実行できません。
export const AlertCodeWAR00001 = 'WAR00001' // 『{0}』は{1}です。
export const AlertCodeWAR00002 = 'WAR00002' // 『{0}』の付録を{1}します。
export const AlertCodeWAR00005 = 'WAR00005' // 資料番号：{0}します。よろしいですか。
